const Currency = ({value}) => {
    function currencyFormat(num) {
        if(typeof num == "string"){
            num = parseFloat(num)
        }
        if(!num){
            return '$0';
        }
        return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }
    return <>{currencyFormat(value)}</>
};
  
export default Currency;

